import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
export var HeaderContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", "px;\n"], ["\n  padding: ", "px;\n"])), function (props) { return (props.padding !== undefined ? props.padding : 20); });
var templateObject_1;
